<template>
  <AndroidComponent v-if="isAndroid" />

  <div v-else class="main" v-motion-fade>
    <template v-if="isIOS">
      <iOSViewComponent />
    </template>
    <template v-else>
      <header>
        <HeaderComponent />
      </header>

      <div class="content">
        <router-view />
      </div>

      <footer>
        <FooterComponent />
      </footer>
    </template>
  </div>
  <YandexMetrika />
</template>

<script>
import HeaderComponent from './components/common/HeaderComponent.vue'
import FooterComponent from './components/common/FooterComponent.vue'
import YandexMetrika from './components/YandexMetrika.vue'
import AndroidComponent from './components/android/AndroidComponent.vue'
import iOSViewComponent from './components/ios/iOSViewComponent.vue'

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent,
    YandexMetrika,
    AndroidComponent,
    iOSViewComponent,
  },
  computed: {
    isAndroid() {
      if (typeof navigator === 'undefined') return false
      return /Android/i.test(navigator.userAgent || '')
    },
    isIOS() {
      if (typeof navigator === 'undefined') return false
      const ua = navigator.userAgent || ''
      return /iPad|iPhone|iPod/i.test(ua) && !window.MSStream
    },
  },
}
</script>

<style></style>
